/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev = FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions;

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsToJSON(value as FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions);
    }

    return {};
}

